import { useMemo, useState } from "react";
import { FilterableAccordion } from "./FilterableAccordion";

export interface FilterableSection<T> {
  key: string;
  title: string;
  items: T[];
  matchText: (item: T) => string;
  renderItems: (items: T[]) => React.ReactNode;
  defaultOpen?: boolean;
}

interface FilterableListProps<T> {
  sections: FilterableSection<T>[];
  placeholder?: string;
}

export function FilterableList<T>({ sections, placeholder = "Filter..." }: FilterableListProps<T>) {
  const [query, setQuery] = useState("");
  const lower = query.toLowerCase();
  const isFiltering = lower.length > 0;

  const hasItems = sections.some((s) => s.items.length > 0);

  const filtered = useMemo(
    () =>
      sections.map((section) => {
        const items = isFiltering
          ? section.items.filter((item) => section.matchText(item).toLowerCase().includes(lower))
          : section.items;
        return { section, items };
      }),
    [sections, lower, isFiltering],
  );

  if (!hasItems) return null;

  return (
    <>
      <input
        className="dt-form-input dt-search-filter"
        type="search"
        placeholder={placeholder}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
      {filtered.map(({ section, items }) => (
        <FilterableAccordion
          key={section.key}
          section={section}
          filteredItems={items}
          isFiltering={isFiltering}
        />
      ))}
    </>
  );
}
